import React from 'react'
import GalleryWithLightbox from '../../../components/gallery-with-lightbox'
import Layout from '../../../components/layout/layout'
import Header from '../../../components/header/header'
import Nav from '../../../components/nav/nav'
import Footer from '../../../components/footer/footer'

import image1 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/1-You Will Be Loved_installation.jpg'
import image2 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/2-Rabbit detail.jpg'
import image3 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/3-Bird detail.jpg'
import image4 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/4-Jar with lid front.jpg'
import image5 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/5-Jar detail back.jpg'
import image6 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/6-Jar detail top.jpg'
import image7 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/7-Dish w_loose flower sculpture.jpg'
import image8 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/8-Dish w_loose flower sculpture-top detail.jpg'
import image9 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/9-Dish w_loose flower sculpture-close up.jpg'
import image10 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/10-Dish with flower attached.jpg'
import image11 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/11-Table center piece.jpg'
import image12 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/12-Small dish w_flower.jpg'
import image13 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/13-Small dish with petals & legs.jpg'
import image14 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/14-Small dish w:loose leaves.jpg'
import image15 from '../../../assets/images/albums/ceramics-and-mixed-media/porcelain/15-Flowers variable sizes.jpg'

export default () => (
  <Layout>
    <Header />
    <Nav />
    <main>
      <div>
        <p>My current studio practice tests the structural limits of porcelain, a notoriously demanding material, by combining traditional hand-building techniques with an innovative mixed-media approach. By stepping away from the immediate results offered by the wheel thrown, I deliberately slow down my process. Hand-building requires a tremendous investment of time and patience, especially with porcelain; it allows me to establish an intimate dialogue with the clay, shaping organic, sculptural forms that evoke the natural world.</p>
        <p>In this innovative group of sculptures, I coat carved, textured surfaces with a classic celadon glaze. After firing at Cone 10 temperatures in reduction atmosphere, this iron-rich, translucent glaze pools beautifully across the forms, imparting a vibrant jade-green hue that evokes timeless beauty.</p>
        <p>The culmination of this experimentation is the installation titled “You Will Be Loved”. In it, the pristine nature of fired porcelain intertwines with the unexpected textures of found objects. I incorporate repurposed feathers, meticulously hand-stitched onto fabric ribbons and attached to the piece, which flutter subtly in the surrounding breeze; alongside, nostalgia-laden objects sourced from flea markets.</p>
        <p>Bridging the past and the present with the used elements, these hybrid sculptures evoke a profound sense of sentimental urgency. Ultimately, “You Will Be Loved” functions as an environmental monument, utilizing the delicate fragility of porcelain and organic remnants of flora and fauna to awaken a vital awareness regarding the current climate crisis.</p>
      </div>
      <br />
      <GalleryWithLightbox
        photos={PHOTO_SET}
        direction='column'
        margin={8}
      />
      <p>
        Photos:&nbsp;
        <a
          href="https://joelbenjamin.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Joel Benjamin
        </a>
      </p>
    </main>
    <Footer />
  </Layout>
)

const PHOTO_SET = [
  {
    src: image1,
    width: 1000,
    height: 667,
    caption: 'You will be loved - Hand-built porcelain with celadon glaze, repurposed feathers and found metal leaves. Wall installation Approx. 10 x 10 ft  - Variable sizes'
  },
  {
    src: image2,
    width: 1000,
    height: 667,
    caption: 'Rabbit detail'
  },
  {
    src: image3,
    width: 1000,
    height: 667,
    caption: 'Bird detail'
  },
  {
    src: image4,
    width: 1000,
    height: 667,
    caption: 'Jar w/ lid front - porcelain with celadon glaze - 7.5”H x 10.5”W x 7.5”Dim.'
  },
  {
    src: image5,
    width: 1000,
    height: 667,
    caption: 'Jar detail, back'
  },
  {
    src: image6,
    width: 1000,
    height: 667,
    caption: 'Jar detail, top'
  },
  {
    src: image7,
    width: 1000,
    height: 667,
    caption: 'Dish w/ loose flower sculpture - porcelain w/ celadon glaze - 3.5”H x 8”Dim - Private collection'
  },
  {
    src: image8,
    width: 1000,
    height: 667,
    caption: 'Dish w/ loose flower sculpture - top detail'
  },
  {
    src: image9,
    width: 1000,
    height: 667,
    caption: 'Dish w/ loose flower sculpture - close up'
  },
  {
    src: image10,
    width: 1000,
    height: 667,
    caption: 'Dish with flower attached - porcelain w/ celadon glaze - 4”H x 8”W'
  },
  {
    src: image11,
    width: 1000,
    height: 667,
    caption: 'Table center piece - porcelain w/ celadon glaze - N/A'
  },
  {
    src: image12,
    width: 1000,
    height: 667,
    caption: 'Small dish & flower - porcelain w/ spodumene glaze -  2.5”H x 4”Dim.'
  },
  {
    src: image13,
    width: 1000,
    height: 667,
    caption: 'Small dish with petals & legs - porcelain w/ celadon glaze - 2.5”H x 4”Dim.'
  },
  {
    src: image14,
    width: 1000,
    height: 667,
    caption: 'Small dish w/loose leaves - porcelain w/ celadon glaze - 2.5”H x 4”Dim.'
  },
  {
    src: image15,
    width: 1000,
    height: 667,
    caption: 'Flowers variable sizes - porcelain w/ celadon glaze'
  }
]
